<template>
    <base-nav class="navbar-top navbar-dark"
              id="navbar-main"
              :show-toggle-button="false"
              expand>
        <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <div class="form-group mb-0">
            </div>
        </form>

        <div class="text-right">
            <span class="font-weight-bold" style="color: white">{{user}}</span>
        </div>

        <!--<ul class="navbar-nav align-items-center d-none d-md-flex">-->
        <!--<li class="nav-item dropdown">-->
        <!--<base-dropdown class="nav-link pr-0">-->
        <!--<div class="media align-items-center" slot="title">-->
        <!--&lt;!&ndash;<span class="avatar avatar-sm rounded-circle">&ndash;&gt;-->
        <!--&lt;!&ndash;<img alt="Image placeholder" src="img/escudo-srb.png">&ndash;&gt;-->
        <!--&lt;!&ndash;</span>&ndash;&gt;-->
        <!---->
        <!--</div>-->

        <!--<template>-->
        <!--&lt;!&ndash;<a href="#" class="dropdown-item">&ndash;&gt;-->
        <!--&lt;!&ndash;<i class="ni ni-button-power"></i>&ndash;&gt;-->
        <!--&lt;!&ndash;<span>Desconectar</span>&ndash;&gt;-->
        <!--&lt;!&ndash;</a>&ndash;&gt;-->
        <!--</template>-->
        <!--</base-dropdown>-->
        <!--</li>-->
        <!--</ul>-->
    </base-nav>
</template>
<script>
    export default {
        data() {
            return {
                activeNotifications: false,
                showMenu: false,
                searchQuery: '',
                user: this.$store.getters.user
            };
        },
        methods: {
            toggleSidebar() {
                this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
            },
            hideSidebar() {
                this.$sidebar.displaySidebar(false);
            },
            toggleMenu() {
                this.showMenu = !this.showMenu;
            }
        }
    };
</script>
